<div class="videoOverlay" *ngIf="showVideoOverlay" @fadeInOut>
    <div class="overlayBackground" (click)="toggleVideoOverlay();closeModal();"></div>
    <button id="exitVideo" (click)="toggleVideoOverlay();closeModal();"
        [ngStyle]="{'top':native ? '40px' : '10px', 'right':native ? '20px' : '10px'}" aria-label="Close"><i
            class="toggled fal fa-times"></i></button>
    <iframe [src]="videoLink | async" id="videoPlayer" width="100%" height="100%" frameborder="0"
        allow="autoplay; fullscreen" allowfullscreen></iframe>
</div>